import { composeIO } from 'react-compose-io'
import { fieldsDescricaoIO } from './FieldsDescricao.IO'
import { FieldsDescricaoView } from './FieldsDescricao.View'

export const FieldsDescricao = composeIO(FieldsDescricaoView, fieldsDescricaoIO)
